import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../Common/InputText';

const AccessCodeForm = ({ userRequest, onContinue, onFormChange, isFormValid }) => {
    const valid = isFormValid ? "" : "was-validated";
    const className = "access-code-form " + valid;
    const msg = "Please enter the access code for the additional subscription that you wish to access. You can use the same access code as a colleague who has access, or you can obtain it from the subscription's administrator or project manager.";
    
    const onChange = (e) => {
        onFormChange(e.target.name, e.target.value);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        onContinue();
    }

    return (
        <form name="access-code-form" onSubmit={onSubmit} className={className} noValidate>
            <div>{msg}</div>
            <br />
            <br />
            <InputText
                name="accessCode"
                label="Access Code"
                type="text"
                placeholder="Access Code"
                value={userRequest.accessCode}
                onChange={onChange}
                isFocused={true}
                isRequired={true}
                errorMessage="Please enter an access code"
            />
        </form>
    );
};

AccessCodeForm.propTypes = {
    userRequest: PropTypes.object.isRequired,
    onContinue: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onFormChange: PropTypes.func.isRequired,
    isFormValid: PropTypes.bool.isRequired
};

export default AccessCodeForm;
